import React from 'react';
import t from 'prop-types';

import Loader from '../../common/Loader';

import styles from './SubmitButton.scss';

/**
 * @param {string} text
 * @param {function} onSubmit
 * @param {?boolean} isLoading - whether to display a loader instead of `text`
 * @param {?string} className
 * @param {?Object} loaderProps - props to pass down to the <Loader> view inside
 * @returns {JSX.Element}
 */
const SubmitButton = ({ text, onSubmit, isLoading, className, loaderProps }) => {
  const onClick = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <button
      onClick={onSubmit ? onClick : undefined}
      className={`${styles.submitButton} ${className} ${isLoading ? styles.hasLoader : ''}`}
      type="submit"
      data-tabable-field="submit"
    >
      {isLoading ? <Loader {...loaderProps} /> : text}
    </button>
  );
};

SubmitButton.propTypes = {
  text: t.string.isRequired,
  onSubmit: t.func,
  isLoading: t.bool,
  className: t.string,
  loaderProps: t.object,
};

export default SubmitButton;
